import React from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import { Box, Flex, Heading } from 'rebass';
import styled from 'styled-components';
import Work from '../../Work';
import Branding from '../../Branding';
import Footer from '../../Footer';
import clients from '../clients';
import ourClients from './images/our_clients.png';

const Container = styled(Flex)`
  height: 100vh;
`;

const H1 = styled(Heading)`
  line-height: 1px;
  height: 1px;
`;

const FullPage = withProps({
  bg: 'brand',
  justify: 'center',
  column: true,
  style: { minHeight: '100vh' },
})(Flex);

const isInHomeOrWorkPage = location =>
  (location.pathname === '/') ||
  (location.pathname === '/work') ||
  (location.pathname === '/work/');

const MobileLayout = ({ children, location }) => (
  <Container column>
    {
      isInHomeOrWorkPage(location) &&
        <FullPage>
          <Branding />
        </FullPage>
    }
    <Box flex="1 1 auto">
      <Box>
        {children()}
      </Box>
      {
        isInHomeOrWorkPage(location) &&
          <Box>
            <FullPage>
              <Flex align="center" column>
                <H1 color="brand">Our Clients</H1>
                <img
                  src={ourClients}
                  alt="Our Clients"
                  style={{ maxWidth: '80%', maxHeight: '80%' }}
                />
              </Flex>
            </FullPage>
            <Work clients={clients} />
          </Box>
      }
    </Box>
    <Footer />
  </Container>
);

MobileLayout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

MobileLayout.defaultProps = {
  children: null,
};

export default MobileLayout;



// WEBPACK FOOTER //
// ./src/layouts/mobile/index.js